import React                    from 'react';
import { List }                 from 'antd';
import { observer }             from 'mobx-react';
import { Button }               from 'antd';
import { DownloadOutlined }     from '@ant-design/icons';
import CardBox                  from 'components/App/CardBox';
import FormattedMessageWrapper  from 'components/App/FormattedMessageWrapper';
import { downloadFileFromUrl }  from 'utils/downloadFile';
import { ApiCollection }        from 'collections/ApiCollection';
import DemandLogisticMediaModel from 'models/DemandLogisticMediaModel';
import MessageMediaModel        from 'models/MessageMediaModel';

interface ContentProps {
  demandLogisticMediaCollection: ApiCollection<DemandLogisticMediaModel>;
  messageMediaCollection: ApiCollection<MessageMediaModel>;
}

const Content = observer(({
  demandLogisticMediaCollection,
  messageMediaCollection,
}: ContentProps) => {
  const items = [];

  const demandLogisticMediaPlan = demandLogisticMediaCollection.findBy('type', 'plan') as DemandLogisticMediaModel;
  if (demandLogisticMediaPlan) {
    items.push({
      id: demandLogisticMediaPlan.id,
      name: <FormattedMessageWrapper id="Plan de positionnement du matériel" />,
      url: demandLogisticMediaPlan.objectUrl,
    });
  }

  const demandLogisticMediaDocument = demandLogisticMediaCollection.findBy('type', 'document') as DemandLogisticMediaModel;
  if (demandLogisticMediaDocument) {
    items.push({
      id: demandLogisticMediaDocument.id,
      name: <FormattedMessageWrapper id="Photo ou document du matériel" />,
      url: demandLogisticMediaDocument.objectUrl,
    });
  }

  messageMediaCollection.forEach((messageMedia: MessageMediaModel) => {
    items.push({
      id: messageMedia.id,
      name: messageMedia.mediaFileName,
      url: messageMedia.objectUrl,
    });
  });

  return (
    <List
      dataSource={items}
      loading={demandLogisticMediaCollection.isLoading || messageMediaCollection.isLoading}
      locale={{
        emptyText: <FormattedMessageWrapper id="Aucun fichier." />,
      }}
      pagination={false}
      renderItem={item => (
        <List.Item key={item.id}>
          <List.Item.Meta title={item.name} />
          <Button
            icon={<DownloadOutlined />}
            onClick={() => downloadFileFromUrl(item.url, item.name.toString())}
          >
            <FormattedMessageWrapper id="Télécharger" />
          </Button>
        </List.Item>
      )}
      size="large"
    />
  );
});

interface DemandMessageMediaListBoxProps {
  demandLogisticMediaCollection: ApiCollection<DemandLogisticMediaModel>;
  messageMediaCollection: ApiCollection<MessageMediaModel>;
}

// eslint-disable-next-line react/prefer-stateless-function
class DemandMessageMediaListBox extends React.Component<DemandMessageMediaListBoxProps> {
  render() {
    const {
      demandLogisticMediaCollection,
      messageMediaCollection,
    } = this.props;

    return (
      <CardBox
        bodyStyle={{ padding: 0 }}
        content={
          <Content
            demandLogisticMediaCollection={demandLogisticMediaCollection}
            messageMediaCollection={messageMediaCollection}
          />
        }
        title={<FormattedMessageWrapper id="Fichiers" />}
      />
    );
  }
}

export default DemandMessageMediaListBox;
